import { useEffect, useState } from "react";
import { selector } from "../../../api";
import { TableShared } from "../../../shared";
import { AlmanacAdd } from "./add";
import { char } from "../../../utils";
import { Button, Dropdown, Space } from "antd";
import {
  MoreOutlined,
} from "@ant-design/icons";
import { Message, useToaster } from "rsuite";
import { appCRUD } from "../../../actions/app";
import moment from "moment";



export const AlmanacContent = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [index, setIndex] = useState(0);
  const toaster = useToaster();

  const user = selector.User();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      appCRUD
        .loadAlmanac(postsPerPage, nextPage, value, "-id")
        .then((resp) => {
          setData(resp.data.results);
          setCount(resp.data.count);
        })
        .catch((error) => {
          toaster.push(
            <Message type="error" showIcon header={"Error"} closable>
              <p className="h6">
                <p className="fw-bold fs-14">Oooh Sorry...!</p>
                <p className="text-dark fs-12">{error}.</p>
              </p>
            </Message>,
            { placement: "topEnd", duration: 7000 }
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }, 500);
  }, [page, postsPerPage, value, index, nextPage]);

  const defaultColumns = [
    {
      key: "sn",
      title: "#",
      dataIndex: "sn",
      fixed: true,
      width: 150,
    },
    {
      key: "academic",
      title: "Academic Year",
      dataIndex: "academic",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "start_date",
      title: "Start Date",
      dataIndex: "start_date",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "end_date",
      title: "End Date",
      dataIndex: "end_date",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      width: 70,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: "Edit",
                key: "edit",
                icon: <i className="ri-edit-circle-line" />,
              },
              {
                label: "View",
                key: "view",
                icon: <i className="ri-eye-line" />,
              },
            ],
            onClick: (event) => {
              switch (event.key) {
                case "1":
                  setOpen(true);
                  break;
                default:
              }
            },
          }}
          trigger={["click"]}
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
        >
          <Space>
            <Button type="dashed" icon={<MoreOutlined />} size={"middle"} />
          </Space>
        </Dropdown>
      ),
    },
  ];

  const dataItem = data?.map((dt, i) => ({
    id: dt.id,
    sn: i + 1,
    academic: dt.academic_year ? dt.academic_year.name : "N/A",
    start_date: moment(dt.start_date).format("ddd. DD MMM YYYY"),
    end_date: moment(dt.end_date).format("ddd. DD MMM YYYY"),
    status: dt.is_active ? (
      <span class="badge badge-soft-success badge-border fs-11">
        {char.toTitleCase("active")}
      </span>
    ) : (
      <span class="badge badge-soft-danger badge-border fs-11">
        {char.toTitleCase("inactive")}
      </span>
    ),
  }));

  const button = (
    <button className="btn btn-primary" onClick={() => setOpen(true)}>
      <span className="bi bi-plus-circle la-lg"></span> &nbsp; New Almanac
    </button>
  );
  

  return (
    <>
      <AlmanacAdd
        open={open}
        setOpen={setOpen}
        index={index}
        setIndex={setIndex}
      />
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-12">
            <p className="h6 fs-18 fw-bold text-primary">Almanac</p>
          </div>
          <hr className="mt-3" />
        </div>
        <TableShared
          setOpen={setOpen}
          loading={loading}
          data={dataItem}
          setData={setData}
          page={page}
          setPage={setPage}
          count={count}
          postsPerPage={postsPerPage}
          setePostPerPage={setePostPerPage}
          setNextPage={setNextPage}
          value={value}
          setValue={setValue}
          defaultColumns={defaultColumns}
          button={button}
          link={"#"}
          showButton={true}
          setLoading={setLoading}
        />
      </div>
    </>
  );
};
